import {
	Component,
	OnInit,
	ViewChild,
	AfterViewInit,
	ChangeDetectorRef,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import _ from "lodash";
import moment from "moment";
import { Subscription } from "rxjs";
import { environment } from "@env";
import { StateService } from "@services/shared/state-service";
import { WorkOrderService } from "../work-order.service";
import {
	TABLE_SCROLL_HEIGHT,
	TABLE_CONFIG,
	CASE_ORIGINS,
	DEFAULT_TIMEOUT,
	DEFAULT_WORK_ORDER_ATTACHMENT_FOLDERS,
	DATE_FORMAT,
	DATE_TIME_FORMAT,
	STATUS_COLOR,
} from "@constant";
import { API_ENDPOINT } from "@constants/http-call.constants";
import { HelperService } from "@services/helper.service";
import { HttpCallService } from "@services/http-calls.service";
import { first, finalize } from "rxjs/operators";
import { Router } from "@angular/router";

import { DataService } from "./data.service";
// import { DayPilot, DayPilotSchedulerComponent } from "daypilot-pro-angular";
import { DateHelperService } from "@services/date-helper.service";
import { TableHelperService } from "../../../../services/table-helper.service";

import { TABLE_COLUMNS } from "../../work-order/listing/constants";
import {
	WORK_ORDER_STATUS_COLOR,
	WORK_ORDER_STATUSES,
	WORK_ORDER_STATUS_REASONS,
	WO_JOBSHEET_TYPES,
} from "@constants/work-order.contants";
import { CASE_STATUS_COLOR, CASE_TYPES } from "@constants/case.contants";
import { Table } from "primeng/table";

import { LoadingScreenService } from "../../../components/common/LoadingScreen/LoadingScreen.service";

import {
	DUMMY_DATA,
	DUMMY_ENGINEERS_RESPONSE,
	GROUP_VALUE,
	EVENT_ACTION,
	DUMMY_SCHEDULED_WORK_ORDER_RESPONSE,
	DUMMY_UNSCHEDULED_WORK_ORDER_RESPONSE,
} from "./constants";
import { EncryptionService } from "../../../../services/encryption.service";
import { DownloadService } from "../../../../components/shared/download/download.service";
import {
	DayPilot,
	DayPilotCalendarComponent,
	DayPilotMonthComponent,
	DayPilotNavigatorComponent,
} from "@daypilot/daypilot-lite-angular";
import { DataDpService } from "./datadp.service";
import { Schedule } from "./components/schedule-grid/schedule-grid.component";

@Component({
	selector: "scheduler-component",
	templateUrl: "./scheduler.component.html",
	styleUrls: ["./scheduler.component.scss"],
})
export class WoSchedulerComponent implements OnInit, AfterViewInit {
	@ViewChild("day") day!: DayPilotCalendarComponent;
	@ViewChild("week") week!: DayPilotCalendarComponent;
	@ViewChild("month") month!: DayPilotMonthComponent;
	@ViewChild("navigator") nav!: DayPilotNavigatorComponent;

	events: DayPilot.EventData[] = [];
	schedules: Schedule[] = [];

	date = DayPilot.Date.today();

	configDay: DayPilot.CalendarConfig = {
		durationBarVisible: false,
		onBeforeEventRender: this.onBeforeEventRender.bind(this),
		onEventClick: this.onEventClick.bind(this),
	};

	onBeforeEventRender(args: any) {
		args.data.cssClass = "calendar_default_event";
		args.data.cssClass = "button.modal_default_cancel";
	}

	async onEventClick(args: any) {
		const form = [
			{
				name: "Description",
				id: "text",
				type: "textarea",
				rows: "2",
				disabled: true,
			},
			{
				name: "Start",
				id: "start",
				dateFormat: "MM/dd/yyyy",
				type: "datetime",
				disabled: true,
			},
			{
				name: "End",
				id: "end",
				dateFormat: "MM/dd/yyyy",
				type: "datetime",
				disabled: true,
			},
			{ name: "Engineer", id: "engineer", type: "text", disabled: true },
		];
		const data = args.e.data;
		const modal = await DayPilot.Modal.form(form, data, {
			cancelText: " ",
			okText: "Close",
		});
		if (modal.canceled) {
			return;
		}
		const dp = args.control;
		dp.events.update(modal.result);
	}

	// @ViewChild("RefDayScheduler") DayScheduler: DayPilotSchedulerComponent;
	@ViewChild("DayPilot_UnscheduleConfirmationModal")
	DayPilot_UnscheduleConfirmationModal;

	@ViewChild("RefUnscheduledWoTable") RefUnscheduledWoTable: Table;
	@ViewChild("RefScheduledWoTable") RefScheduledWoTable: Table;
	@ViewChild("RefSelectedDayWoTable") RefSelectedDayWoTable: Table;

	TABLE_CONFIG = TABLE_CONFIG;
	TESTING_MODE = false;
	LODASH = _;
	TABLE_SCROLL_HEIGHT: Object = TABLE_SCROLL_HEIGHT;

	WORK_ORDER_STATUS_REASONS: Array<Object> = WORK_ORDER_STATUS_REASONS;
	WORK_ORDER_STATUSES = WORK_ORDER_STATUSES;
	CASE_TYPES = CASE_TYPES;
	WO_JOBSHEET_TYPES = WO_JOBSHEET_TYPES;
	WORK_ORDER_STATUS_COLOR = WORK_ORDER_STATUS_COLOR;
	CASE_STATUS_COLOR = CASE_STATUS_COLOR;
	TABLE_COLUMNS = TABLE_COLUMNS;

	VIEW_DAY = "Day";
	VIEW_MONTH = "Month";
	TAB_UNSCHEDULED = "Unscheduled";
	TAB_SCHEDULED = "Scheduled";
	TAB_SELECTED = "By Selected Date";
	MONTH_LISTING_TYPE_FILTERED = "filtered";

	WORK_ORDER_LISTING_TABS = [
		this.TAB_UNSCHEDULED,
		this.TAB_SCHEDULED,
		this.TAB_SELECTED,
	];

	GROUP_TEAM_GROUP = { text: "Team Group", value: GROUP_VALUE.TEAM_GROUP };
	GROUP_BRANCH = { text: "Branch", value: GROUP_VALUE.BRANCH };
	GROUP_SKILLSET_A_PRINCIPAL = {
		text: "Skillset A Principal",
		value: GROUP_VALUE.A_PRINCIPAL,
	};
	GROUP_SKILLSET_B_CARE_AREA = {
		text: "Skillset B Care Area",
		value: GROUP_VALUE.B_CARE_AREA,
	};
	GROUP_SKILLSET_C_OPC = { text: "Skillset C OPC", value: GROUP_VALUE.C_OPC };
	GROUP_SKILLSET_D_REGION = {
		text: "Skillset D Region",
		value: GROUP_VALUE.D_REGION,
	};
	GROUP_SKILLSET_MODEL = { text: "Skillset Model", value: GROUP_VALUE.MODEL };
	GROUP_SKILLSET_SERVICE_TASK = {
		text: "Skillset Service Task",
		value: GROUP_VALUE.SERVICE_TASK,
	};
	GROUP_FUNCTIONAL_OPC = {
		text: "Functional OPC",
		value: GROUP_VALUE.FUNCTIONAL_OPC,
	};
	GROUP_SUB_TEAM = { text: "BME Sub Team", value: GROUP_VALUE.SUB_TEAM };
	GROUP_CUSTOMIZE_GROUP = {
		text: "BME Customize Team",
		value: GROUP_VALUE.CUSTOMIZE_GROUP,
	};

	GROUP_BY_OPTIONS = [
		this.GROUP_TEAM_GROUP,
		this.GROUP_BRANCH,
		this.GROUP_SKILLSET_A_PRINCIPAL,
		this.GROUP_SKILLSET_B_CARE_AREA,
		this.GROUP_SKILLSET_C_OPC,
		this.GROUP_SKILLSET_D_REGION,
		this.GROUP_SKILLSET_MODEL,
		this.GROUP_SKILLSET_SERVICE_TASK,
		this.GROUP_FUNCTIONAL_OPC,
		this.GROUP_SUB_TEAM,
		this.GROUP_CUSTOMIZE_GROUP,
	];

	TEAM_GROUP_OPTIONS = [];
	BRANCH_OPTIONS = [];
	A_PRINCIPAL_OPTIONS = [];
	B_CARE_AREA_OPTIONS = [];
	C_OPC_OPTIONS = [];
	D_REGION_OPTIONS = [];
	MODEL_OPTIONS = [];
	SERVICE_TASK_OPTIONS = [];
	FUNCTIONAL_OPC_OPTIONS = [];
	SUB_TEAM_OPTIONS = [];
	ENGINEER_OPTIONS = [];
	engineerMap: Map<string, any> = new Map();
	CUSTOMIZE_GROUP_OPTIONS = [];
	HOLIDAYS = [];
	VENDOR_OPTIONS = [];
	EMPLOYEE_TYPE_OPTIONS = [
		{
			text: "Internal",
			value: "internal",
		},
		{
			text: "External",
			value: "external",
		},
	];

	isShowClosedWorkOrder = true;
	isLoadingCalendar = false;

	calendarEventsV2: any[] = [];

	schedulerConfig = {
		view: this.VIEW_DAY,
		selected_date_ranges: null,
		selected_month: moment().toDate(),
		group_by: this.GROUP_TEAM_GROUP.value,
		filter: {
			team_groups: [],
			branches: [],
			agencies: [],
			b_care_araes: [],
			opcs: [],
			regions: [],
			skill_equipments: [],
			skill_service_tasks: [],
			// functional_opc: [],
			[GROUP_VALUE.FUNCTIONAL_OPC]: [],
			[GROUP_VALUE.SUB_TEAM]: [],
			[GROUP_VALUE.CUSTOMIZE_GROUP]: [],
			engineers: [],
			[GROUP_VALUE.VENDOR]: [],
			[GROUP_VALUE.EMPLOYEE_TYPE]: [],
		},
	};

	valueMappings = {
		[GROUP_VALUE.TEAM_GROUP]: {
			key_in_engineer: "team_group",
			options: this.TEAM_GROUP_OPTIONS,
		},
		[GROUP_VALUE.BRANCH]: {
			key_in_engineer: "branches",
			options: this.BRANCH_OPTIONS,
		},
		[GROUP_VALUE.A_PRINCIPAL]: {
			key_in_engineer: "agencies",
			options: this.A_PRINCIPAL_OPTIONS,
		},
		[GROUP_VALUE.B_CARE_AREA]: {
			key_in_engineer: "care_areas",
			options: this.B_CARE_AREA_OPTIONS,
		},
		[GROUP_VALUE.C_OPC]: {
			key_in_engineer: "opcs",
			options: this.C_OPC_OPTIONS,
		},
		[GROUP_VALUE.D_REGION]: {
			key_in_engineer: "regions",
			options: this.D_REGION_OPTIONS,
		},
		[GROUP_VALUE.MODEL]: {
			key_in_engineer: "skill_equipments",
			options: this.MODEL_OPTIONS,
		},
		[GROUP_VALUE.SERVICE_TASK]: {
			key_in_engineer: "skill_service_tasks",
			options: this.SERVICE_TASK_OPTIONS,
		},
		[GROUP_VALUE.FUNCTIONAL_OPC]: {
			key_in_engineer: "functional_opc",
			options: this.FUNCTIONAL_OPC_OPTIONS,
		},
		[GROUP_VALUE.SUB_TEAM]: {
			key_in_engineer: "sub_bme_teams",
			options: this.SUB_TEAM_OPTIONS,
		},
		[GROUP_VALUE.CUSTOMIZE_GROUP]: {
			key_in_engineer: "customize_teams",
			options: this.CUSTOMIZE_GROUP_OPTIONS,
		},
		[GROUP_VALUE.VENDOR]: {
			key_in_engineer: "vendor_external_id",
			options: this.VENDOR_OPTIONS,
		},
		[GROUP_VALUE.EMPLOYEE_TYPE]: {
			key_in_engineer: "employee_type",
			options: this.EMPLOYEE_TYPE_OPTIONS,
		},
	};

	unscheduledWorkOrders: any[] = [];
	dayPilotEvents = []; // DayPilot.EventData[]

	rangeDates: any = [];
	appliedStartDate: Date = null;
	appliedEndDate: Date = null;
	filters: any = {
		start_date: null,
		end_date: null,
	};

	TOTAL_CALENDAR_ELEMENTS = new Array(35);
	monthCalendarConfig = {
		rows: [],
	};
	selectedMonthItem = null;
	errorReschedule = "not allow to reschedule";

	filteredEngineers = [];
	subscriptions: Array<Subscription> = [];
	// Work Order Table
	isAdvancedFilterCollapse = true;
	isWorkOrderSectionCollapse = false;
	activeTab = this.TAB_UNSCHEDULED;

	DEFAULT_TABLE_CONFIG = {
		search_key: "",
		columns_value: _.map(TABLE_COLUMNS, "field"),
		columns: TABLE_COLUMNS,
		entries: TABLE_CONFIG.ENTRIES_PER_PAGE,
		total_entries: 0,
		page: 1,
		sort_key: "",
		sort_direction: "asc",
		active_type: "",
		filters: {},
		constant_filters: {},
	};

	unscheduledWosListing = [];
	unscheduledWosSelected = [];
	isFirstLoadingTable = true;
	unscheduledWoTableConfig = _.cloneDeep(this.DEFAULT_TABLE_CONFIG);

	scheduledWosListing = [];
	scheduledWosSelected = [];
	scheduledWoTableConfig: any = {
		columns: TABLE_COLUMNS,
		columns_value: _.map(TABLE_COLUMNS, "field"),
	};

	byDatesWosListing = [];
	byDatesWosSelected = [];
	byDatesWoTableConfig: any = {
		columns: TABLE_COLUMNS,
		columns_value: _.map(TABLE_COLUMNS, "field"),
	};

	private reloadTableTimeouts: { [key: string]: any } = {};
	private previousTableParams: { [key: string]: string } = {};
	private isTableLoading: { [key: string]: boolean } = {};
	private loadedTabs: Set<string> = new Set([this.TAB_UNSCHEDULED]);

	wosListingChanged = [];
	// DAYPILOT_DEFAULT_DURATION = this.durationFromMinutes(60);

	isSaving = false;
	isSaved = false;

	constructor(
		public workOrderService: WorkOrderService,
		private stateService: StateService,
		private helperService: HelperService,
		private dataService: DataService,
		private dateHelperService: DateHelperService,
		private tableHelperService: TableHelperService,
		private loadingScreenService: LoadingScreenService,
		private cd: ChangeDetectorRef,
		private encryptionService: EncryptionService,
		public downloadService: DownloadService,
		private dataDpService: DataDpService
	) {
		this.stateService.pageInfo.next({
			title: "WORK ORDER SCHEDULER",
			icon: "mdi mdi-calendar-multiselect-outline",
		});
	}

	ngOnInit(): void {
		this.dateHelperService.initDateRangePicker({
			datePickerRangeDates: this.rangeDates,
		});
		this.dateHelperService.seStartAndEndDates({
			datePickerRangeDates: this.rangeDates,
			startDateString: this.filters.start_date,
			endDateString: this.filters.end_date,
		});

		this.appliedStartDate = this.rangeDates[0];
		this.appliedEndDate = this.rangeDates[1];

		this.initPage();
	}

	private async initPage() {
		// console.log("initPage() Start");

		this.isLoadingCalendar = true;
		this.cd.detectChanges();

		// Group all calendar-related APIs together
		const holidaysPromise = this.preloadHolidays();
		const engineersPromise = this.preloadEngineerOptions();
		const calendarEventsPromise = this.sendGetScheduledListingRequest(true, false);

		// Work orders table API
		const unscheduledPromise = this.sendGetUnscheduledListingRequest();

		// Defer secondary dropdown filter options so critical network sockets are not blocked
		setTimeout(() => {
			this.preloadAllDropdownOptions();
		}, 50);

		// Wait for ALL calendar-related APIs to complete together
		await Promise.all([
			holidaysPromise,
			engineersPromise,
			calendarEventsPromise,
		]);

		// Build the calendar with engineers, holidays, and events ready
		this.reloadPageData();

		// Turn off the calendar shimmer once the calendar is completely ready
		this.isLoadingCalendar = false;
		this.cd.detectChanges();

		// Await unscheduled work orders table
		await unscheduledPromise;

		// console.log("initPage() End");
	}

	private preloadAllDropdownOptions() {
		this.preloadTeamGroupOptions();
		this.preloadBranchOptions();
		this.preloadAPrincipalOptions();
		this.preloadBCareAreaOptions();
		this.preloadCOpcOptions();
		this.preloadDRegionOptions();
		this.preloadModelOptions();
		this.preloadServiceTaskOptions();
		this.preloadFunctionalOpcOptions();
		this.preloadBmeTeamOptions();
		this.preloadCustomizeGroupOptions();
		this.preloadVendorOptions();
	}

	preloadHolidays() {
		return new Promise((resolve, reject) => {
			if (this.TESTING_MODE) {
				let response = DUMMY_ENGINEERS_RESPONSE;
				this.ENGINEER_OPTIONS = _.get(response, "data.data", []);
				resolve(true);
			} else {
				this.helperService
					.getListing(`public-holidays`, {
						per_page: 99999,
						skip_permission: 1,
					})
					.pipe(
						first(),
						finalize(() => resolve(true))
					)
					.subscribe((response: any) => {
						this.HOLIDAYS = _.get(response, "data.data", []);
					});
			}
		});
	}

	buildEngineerMap() {
		this.engineerMap.clear();
		for (const eng of this.ENGINEER_OPTIONS) {
			if (eng.id != null) {
				this.engineerMap.set(String(eng.id), eng);
			}
			if (eng.external_id != null) {
				this.engineerMap.set(String(eng.external_id), eng);
			}
		}
	}

	preloadEngineerOptions() {
		return new Promise((resolve, reject) => {
			// console.log("CHECK TESTING MODE");
			// console.log(this.TESTING_MODE);
			if (this.TESTING_MODE) {
				let response = DUMMY_ENGINEERS_RESPONSE;
				this.ENGINEER_OPTIONS = _.get(response, "data.data", []);
				this.buildEngineerMap();
				resolve(true);
			} else {
				let edges =
					"branches,sub_bme_teams,agencies,care_areas,opcs,regions,team_group,customize_teams,skill_service_tasks,skill_equipments,functional_opc";
				this.helperService
					.getListing(API_ENDPOINT.EMPLOYEES_V2, {
						edges: edges,
						per_page: 99999,
						skip_permission: 1,
						// custom_filter: true,
						// custom_filter_pairs: {
						// 	team_group: [_.get(this.helperService.getUser(), 'team_group')]
						// }
					})
					.pipe(
						first(),
						finalize(() => resolve(true))
					)
					.subscribe((response: any) => {
						this.ENGINEER_OPTIONS = _.chain(response)
							.get("data.data", [])
							.filter({
								team_group: _.get(
									this.helperService.getUser(),
									"team_group"
								),
							})
							.sortBy(["full_name"])
							.value();
						this.buildEngineerMap();
					});
			}
		});
	}
	preloadTeamGroupOptions() {
		this.TEAM_GROUP_OPTIONS = [
			{
				value: "apps",
				text: "Apps",
			},
			{
				value: "service",
				text: "Service",
			},
		];

		this.valueMappings[GROUP_VALUE.TEAM_GROUP]["options"] =
			this.TEAM_GROUP_OPTIONS;
	}

	private preloadOptions({
		optionsKey = "",
		optionsValueKey = "",
		optionsTextKey = "",
		group = "",
		listingUrl = "",
		skipOptionByKey = null,
		skipOptionByValues = null,
	}) {
		if (this.TESTING_MODE) {
			// let response = DUMMY_ENGINEERS_RESPONSE;
			// options = _.get(response, 'data.data', [])
			// this.valueMappings[group]['options'] = options
			return;
		}

		if (listingUrl == "equipments") {
			let newOptions = _.chain(this.ENGINEER_OPTIONS)
				.map("skill_equipments", [])
				.flatten()
				.uniqBy("id")
				.map((item) => {
					return {
						...item,
						value: item[optionsValueKey],
						text: item[optionsTextKey],
					};
				})
				.sortBy(["external_id"])
				.value();

			this[optionsKey] = newOptions;
			this.valueMappings[group]["options"] = newOptions;

			return;
		}

		this.helperService
			.getListing(
				listingUrl,
				{ per_page: 99999, skip_permission: 1, skip_loading: 1 },
				true
			)
			.pipe(first())
			.subscribe((response: any) => {
				let newOptions = _.chain(response)
					.get("data.data", [])
					.map((item) => {
						return {
							...item,
							value: item[optionsValueKey],
							text: item[optionsTextKey],
						};
					})
					.sortBy([optionsTextKey])
					.value();

				if (skipOptionByKey && skipOptionByValues) {
					newOptions = _.filter(newOptions, (item) => {
						return !_.includes(
							skipOptionByValues,
							_.lowerCase(item[skipOptionByKey])
						);
					});
				}

				this[optionsKey] = newOptions;
				this.valueMappings[group]["options"] = newOptions;
			});
	}

	preloadBranchOptions() {
		let params = {
			listingUrl: "branches",
			group: GROUP_VALUE.BRANCH,
			optionsKey: "BRANCH_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "branch_name",
			skipOptionByKey: "status_reason",
			skipOptionByValues: ["inactive"],
		};

		this.preloadOptions(params);
	}
	preloadVendorOptions() {
		let params = {
			listingUrl: "vendors",
			group: GROUP_VALUE.VENDOR,
			optionsKey: "VENDOR_OPTIONS",
			optionsValueKey: "external_id",
			optionsTextKey: "name",
		};

		this.preloadOptions(params);
	}

	preloadAPrincipalOptions() {
		let params = {
			listingUrl: "a-principle",
			group: GROUP_VALUE.A_PRINCIPAL,
			optionsKey: "A_PRINCIPAL_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "agency",
		};

		this.preloadOptions(params);
	}
	preloadBCareAreaOptions() {
		let params = {
			listingUrl: "b-care-area",
			group: GROUP_VALUE.B_CARE_AREA,
			optionsKey: "B_CARE_AREA_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "care_area",
		};

		this.preloadOptions(params);
	}
	preloadCOpcOptions() {
		let params = {
			listingUrl: "c-opc",
			group: GROUP_VALUE.C_OPC,
			optionsKey: "C_OPC_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "opc",
		};

		this.preloadOptions(params);
	}
	preloadDRegionOptions() {
		let params = {
			listingUrl: "d-region",
			group: GROUP_VALUE.D_REGION,
			optionsKey: "D_REGION_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "region",
		};

		this.preloadOptions(params);
	}
	preloadModelOptions() {
		let params = {
			listingUrl: "equipments",
			group: GROUP_VALUE.MODEL,
			optionsKey: "MODEL_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "name",
		};

		this.preloadOptions(params);
	}
	preloadServiceTaskOptions() {
		let params = {
			listingUrl: "service-tasks",
			group: GROUP_VALUE.SERVICE_TASK,
			optionsKey: "SERVICE_TASK_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "description",
		};

		this.preloadOptions(params);
	}
	preloadFunctionalOpcOptions() {
		let params = {
			listingUrl: "functional-opc",
			group: GROUP_VALUE.FUNCTIONAL_OPC,
			optionsKey: "FUNCTIONAL_OPC_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "functional_opc_code",
			skipOptionByKey: "status_reason",
			skipOptionByValues: ["inactive"],
		};

		this.preloadOptions(params);
	}
	preloadBmeTeamOptions() {
		let params = {
			listingUrl: "sub-bme-teams",
			group: GROUP_VALUE.SUB_TEAM,
			optionsKey: "SUB_TEAM_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "team_name",
			skipOptionByKey: "status_reason",
			skipOptionByValues: ["inactive"],
		};

		this.preloadOptions(params);
	}
	preloadCustomizeGroupOptions() {
		let params = {
			listingUrl: "customize-teams",
			group: GROUP_VALUE.CUSTOMIZE_GROUP,
			optionsKey: "CUSTOMIZE_GROUP_OPTIONS",
			optionsValueKey: "id",
			optionsTextKey: "team_name",
			skipOptionByKey: "status_reason",
			skipOptionByValues: ["inactive"],
		};

		this.preloadOptions(params);
	}

	ngAfterViewInit(): void {}

	getDayPilotResources({ group_by, groups, engineers }) {
		let resources = [];
		_.each(groups, (group) => {
			let resourceChildren = _.chain(engineers)
				.filter((item) => {
					if (group_by == "team_group") {
						return item[group_by] == group.value;
					}
					if (group_by === "skillset_c_opc") {
						let ids = item[group_by] || [];
						return ids.includes(group.value);
					}
					if (Array.isArray(item[group_by])) {
						let ids = _.map(item[group_by], "id");
						return ids.includes(group.value);
					}
					return false;
				})
				.map((item) => {
					return {
						...item,
						id: item.external_id,
						name: item.full_name,
					};
				})
				.value();
			if (resourceChildren.length > 0) {
				resources.push({
					id: group.value,
					name: group.text,
					expanded: true,
					children: resourceChildren,
				});
			}
		});
		return resources;
	}

	loadEvents(): void {
		let groupBy = _.get(this.schedulerConfig, "group_by");
		let selectedGroupIds = _.get(this.schedulerConfig, `filter.${groupBy}`);
		let allGroups = _.get(this.valueMappings, `${groupBy}.options`);

		let groups = selectedGroupIds?.length
			? allGroups.filter((group) =>
					selectedGroupIds.includes(group.value)
			  )
			: allGroups || [];

		let engineers = this.getFilteredEngineers();
		let params = {
			group_by: _.get(this.valueMappings, `${groupBy}.key_in_engineer`),
			groups,
			engineers,
		};

		const groupByMapping: { [key: string]: string } = {
			TEAM_GROUP: "team_group",
			branches: "branches",
			vendors: "vendors",
			agencies: "agencies",
			care_areas: "care_areas",
			opcs: "opcs",
			regions: "regions",
			skill_equipments: "skill_equipments",
			skill_service_tasks: "skill_service_tasks",
			functional_opc: "functional_opc",
			sub_bme_teams: "sub_bme_teams",
			customize_teams: "customize_teams",
			employee_types: "employee_types",
		};

		const tmpResources = this.getDayPilotResources(params);
		const tmpResourcesId = new Set(
			tmpResources.flatMap((r) => r.children.map((c) => c.id))
		);

		let schedulesFromEvents = this.calendarEventsV2
			.filter((item) => tmpResourcesId.has(item.engineer_id))
			.map((item) => {
				var filterKey = groupByMapping[groupBy];
				var engId = String(item.engineer_id);
				var fullEngineerObj = this.engineerMap.get(engId) || this.ENGINEER_OPTIONS.find(e => e.id == engId || e.external_id == engId);
				var groupName = fullEngineerObj ? this.getGroupName(
					fullEngineerObj,
					filterKey
				) : "";

				if (
					groupBy === "team_groups" &&
					fullEngineerObj?.team_group
				) {
					groupName = fullEngineerObj.team_group;
				} else {
					groupName = groupName ?? "";
				}

				return {
					id: String(item.id),
					name: item.engineer_name,
					endTime: item.appoinment_end,
					startTime: item.appoinment_start,
					workOrderMainId: item.id,
					workOrderId: item.work_order_id,
					title: item.title,
					backColor: STATUS_COLOR[item.status],
					groupName: groupName,
					engineerId: item.engineer_id,
					status: item.status_reason,
				};
			});

		let existingEngineers = new Set(
			schedulesFromEvents.map((schedule) => schedule.name)
		);

		const filterEngineersByGroup = (emp: any): boolean => {
			let filterKey = groupByMapping[groupBy];
			return filterKey
				? emp[filterKey] && emp[filterKey].length > 0
				: true;
		};

		let schedulesFromEngineers = engineers
			.filter((emp) => !existingEngineers.has(emp.full_name))
			.filter(filterEngineersByGroup)
			.map((engineer) => {
				var filterKey = groupByMapping[groupBy];
				var groupName = this.getGroupName(engineer, filterKey);

				if (groupBy === "team_groups" && engineer?.team_group) {
					groupName = engineer.team_group;
				} else {
					groupName = groupName ?? "";
				}

				return {
					id: engineer.id,
					name: engineer.full_name,
					endTime: null,
					startTime: null,
					workOrderMainId: null,
					workOrderId: null,
					title: null,
					backColor: "#CCCCCC",
					groupName: groupName,
				};
			});

		this.schedules = [...schedulesFromEvents, ...schedulesFromEngineers];
		
		this.appliedStartDate = this.rangeDates[0];
		this.appliedEndDate = this.rangeDates[1];
	}

	ngOnDestroy() {
		_.forEach(this.reloadTableTimeouts, (timeout) => clearTimeout(timeout));
		this.clearSubscription();
	}

	reloadPageData() {
		this.setMonthCalendarConfig();

		this.cd.detectChanges();
		this.loadEvents();
	}

	async saveChanges(skipLoading = false) {
		this.isSaving = true;
		this.isSaved = false;

		let params = {
			workOrders: this.wosListingChanged,
		};

		let tempSubscription = this.workOrderService
			.bulkUpdateSchedulerWos(params, skipLoading)
			.pipe(
				first(),
				finalize(() => {
					this.isSaving = false;
					this.isSaved = true;
				})
			)
			.subscribe(async (response) => {
				this.reloadPageData();
				this.wosListingChanged = [];
				tempSubscription.unsubscribe();
			});
	}

	handleUnschedule(schedule: Schedule): void {
		this.isLoadingCalendar = true;
		const updatedSchedule = this.updateAppointmentTime(schedule);
		let params = {
			workOrders: [
				{
					appoinment_start: updatedSchedule.appoinment_start,
					appoinment_end: updatedSchedule.appoinment_end,
					engineer_id: String(updatedSchedule.engineerId),
					work_order_id: updatedSchedule.workOrderId,
				},
			],
		};

		this.schedules = null;
		this.reloadPageData();

		let isReschedulable = this.isReschedulable({
			statusReason: updatedSchedule.status,
		});
		if (!isReschedulable) {
			this.helperService.errorMessage(
				`${updatedSchedule.workOrderId} ${this.errorReschedule}`
			);
			return;
		}

		let tempSubscription = this.workOrderService
			.bulkUpdateSchedulerWos(params)
			.pipe(
				first(),
				finalize(() => {
					this.isLoadingCalendar = false;
					window.location.reload();
				})
			)
			.subscribe({
				next: async (response) => {
					this.reloadPageData();
					this.isSaving = false;
					this.isSaved = true;
				},
				error: (err) => {
					this.reloadPageData();
					console.error("Error updating scheduler:", err);
				},
				complete: () => {
					this.reloadPageData();
					tempSubscription.unsubscribe();
				},
			});
	}

	applyFilter() {
		this.reloadPageData();

		this.RefUnscheduledWoTable.reset();
		this.RefScheduledWoTable.reset();
		this.RefSelectedDayWoTable.reset();

		this.loadingScreenService.startLoading();
		setTimeout(() => {
			this.loadingScreenService.stopLoading();
		}, 500);
	}

	applyFilterToListing() {
		let engineers = _.get(this.schedulerConfig, "filter.engineers", []);
		if (engineers.length == 0) {
			return;
		}

		let filterValues = _.map(engineers, (item) => {
			return {
				value: item.full_name,
				matchMode: "equals",
				operator: "or",
			};
		});

		_.set(
			this.unscheduledWoTableConfig,
			"filters.engineer_full_name",
			filterValues
		);
		_.set(
			this.RefUnscheduledWoTable,
			"filters.engineer_full_name",
			filterValues
		);
		this.RefUnscheduledWoTable._filter();
		this.sendGetUnscheduledListingRequest();

		_.set(
			this.scheduledWoTableConfig,
			"filters.engineer_full_name",
			filterValues
		);
		_.set(
			this.RefScheduledWoTable,
			"filters.engineer_full_name",
			filterValues
		);
		this.RefScheduledWoTable._filter();

		_.set(
			this.byDatesWoTableConfig,
			"filters.engineer_full_name",
			filterValues
		);
		_.set(
			this.RefSelectedDayWoTable,
			"filters.engineer_full_name",
			filterValues
		);
		this.RefSelectedDayWoTable._filter();
	}

	private async sendGetScheduledListingRequest(
		skipLoading = true,
		autoStopLoading = true
	) {
		// console.log("sendGetScheduledListingRequest()");
		let startDate = null;
		let endDate = null;

		if (this.schedulerConfig.view == this.VIEW_DAY) {
			startDate = moment(this.rangeDates[0]).format(DATE_FORMAT);
			endDate = moment(this.rangeDates[1]).format(DATE_FORMAT);
		} else if (this.schedulerConfig.view == this.VIEW_MONTH) {
			startDate = moment(this.schedulerConfig.selected_month)
				.startOf("month")
				.format(DATE_FORMAT);
			endDate = moment(this.schedulerConfig.selected_month)
				.endOf("month")
				.format(DATE_FORMAT);
		}

		this.isLoadingCalendar = true;
		this.cd.detectChanges();

		return new Promise((resolve, reject) => {
			let queryParams: any = {
				skip_permission: 1,
				skip_loading: 1,
				start_date: startDate,
				end_date: endDate,
				show_closed_work_order: this.isShowClosedWorkOrder,
			};

			this.helperService
				.getListing(API_ENDPOINT.SCHEDULER_V2_CALENDAR, queryParams, true)
				.pipe(
					first(),
					finalize(() => {
						if (autoStopLoading) {
							setTimeout(() => {
								this.isLoadingCalendar = false;
								this.cd.detectChanges();
							}, 50);
						}
					})
				)
				.subscribe({
					next: (response: any) => {
						this.calendarEventsV2 = _.get(response, "data", []);
						this.byDatesWosSelected = [];
						if (autoStopLoading) {
							this.reloadPageData();
						}
						resolve(true);
					},
					error: () => {
						this.calendarEventsV2 = [];
						if (autoStopLoading) {
							this.isLoadingCalendar = false;
							this.cd.detectChanges();
						}
						resolve(false);
					}
				});
		});
	}

	onChangeCalendarView() {
		this.isLoadingCalendar = true;
		this.cd.detectChanges();
		this.sendGetScheduledListingRequest();
	}

	onGroupByChange() {
		this.isLoadingCalendar = true;
		this.cd.detectChanges();
		setTimeout(() => {
			this.reloadPageData();
			this.isLoadingCalendar = false;
			this.cd.detectChanges();
		}, 50);
	}

	private async sendGetScheduledTableListingRequest() {
		if (this.isTableLoading[this.TAB_SCHEDULED]) {
			return Promise.resolve(false);
		}
		this.isTableLoading[this.TAB_SCHEDULED] = true;

		return new Promise((resolve, reject) => {
			let params = this.tableHelperService.convertConfigToRequestParams(
				this.scheduledWoTableConfig
			);

			let startDate = null;
			let endDate = null;

			if (this.schedulerConfig.view == this.VIEW_DAY) {
				startDate = moment(this.rangeDates[0]).format(DATE_FORMAT);
				endDate = moment(this.rangeDates[1]).format(DATE_FORMAT);
			} else if (this.schedulerConfig.view == this.VIEW_MONTH) {
				startDate = moment(this.schedulerConfig.selected_month)
					.startOf("month")
					.format(DATE_FORMAT);
				endDate = moment(this.schedulerConfig.selected_month)
					.endOf("month")
					.format(DATE_FORMAT);
			}

			params.start_date = startDate;
			params.end_date = endDate;
			params.show_closed_work_order = this.isShowClosedWorkOrder;

			let tableParams = _.cloneDeep(
				this.helperService.convertToTableListingParams(params)
			);
			this.previousTableParams[this.TAB_SCHEDULED] =
				this.helperService.convertQueryParams(tableParams, "");

			this.subscriptions.push(
				this.workOrderService
					.getScheduledListingPaginated(params)
					.pipe(
						first(),
						finalize(() => {
							this.isTableLoading[this.TAB_SCHEDULED] = false;
						})
					)
					.subscribe({
						next: (response: any) => {
							this.scheduledWosListing = _.get(
								response,
								"data.data",
								[]
							);
							this.scheduledWoTableConfig =
								this.tableHelperService.setTableConfigFromServerResponse(
									this.scheduledWoTableConfig,
									response
								);
							this.scheduledWosSelected = [];
							this.loadedTabs.add(this.TAB_SCHEDULED);
							this.cd.detectChanges();
							resolve(true);
						},
						error: () => {
							this.cd.detectChanges();
							resolve(false);
						}
					})
			);
		});
	}

	private async sendGetByDatesTableListingRequest() {
		if (this.isTableLoading[this.TAB_SELECTED]) {
			return Promise.resolve(false);
		}
		this.isTableLoading[this.TAB_SELECTED] = true;

		return new Promise((resolve, reject) => {
			let params = this.tableHelperService.convertConfigToRequestParams(
				this.byDatesWoTableConfig
			);

			let dateStr = moment(this.selectedMonthItem?.date).format(DATE_FORMAT);
			params.start_date = dateStr;
			params.end_date = dateStr;
			params.show_closed_work_order = this.isShowClosedWorkOrder;

			let tableParams = _.cloneDeep(
				this.helperService.convertToTableListingParams(params)
			);
			this.previousTableParams[this.TAB_SELECTED] =
				this.helperService.convertQueryParams(tableParams, "");

			this.subscriptions.push(
				this.workOrderService
					.getScheduledListingPaginated(params)
					.pipe(
						first(),
						finalize(() => {
							this.isTableLoading[this.TAB_SELECTED] = false;
						})
					)
					.subscribe({
						next: (response: any) => {
							this.byDatesWosListing = _.get(
								response,
								"data.data",
								[]
							);
							this.byDatesWoTableConfig =
								this.tableHelperService.setTableConfigFromServerResponse(
									this.byDatesWoTableConfig,
									response
								);
							this.byDatesWosSelected = [];
							this.loadedTabs.add(this.TAB_SELECTED);
							this.cd.detectChanges();
							resolve(true);
						},
						error: () => {
							this.cd.detectChanges();
							resolve(false);
						}
					})
			);
		});
	}

	private async sendGetUnscheduledListingRequest() {
		// console.log("sendGetUnscheduledListingRequest()");
		if (this.isTableLoading[this.TAB_UNSCHEDULED]) {
			return Promise.resolve(false);
		}
		this.isTableLoading[this.TAB_UNSCHEDULED] = true;

		return new Promise((resolve, reject) => {
			let params = this.tableHelperService.convertConfigToRequestParams(
				this.unscheduledWoTableConfig
			);
			let tableParams = _.cloneDeep(
				this.helperService.convertToTableListingParams(params)
			);
			this.previousTableParams[this.TAB_UNSCHEDULED] =
				this.helperService.convertQueryParams(tableParams, "");

			this.subscriptions.push(
				this.workOrderService
					.getUnscheduleListing(params)
					.pipe(
						first(),
						finalize(() => {
							this.isTableLoading[this.TAB_UNSCHEDULED] = false;
						})
					)
					.subscribe({
						next: (response: any) => {
							this.unscheduledWosListing = _.get(
								response,
								"data.data",
								[]
							);
							this.unscheduledWoTableConfig =
								this.tableHelperService.setTableConfigFromServerResponse(
									this.unscheduledWoTableConfig,
									response
								);
							this.isFirstLoadingTable = false;
							this.loadedTabs.add(this.TAB_UNSCHEDULED);
							this.cd.detectChanges();
							resolve(true);
						},
						error: () => {
							this.isFirstLoadingTable = false;
							this.cd.detectChanges();
							resolve(false);
						}
					})
			);
		});
	}

	clearSubscription() {
		_.forEach(this.subscriptions, (v) => v.unsubscribe());
	}

	onSelectRangeDate(calendar: any) {
		if (this.rangeDates && this.rangeDates[0] && this.rangeDates[1]) {
			if (calendar && typeof calendar.hideOverlay === "function") {
				setTimeout(() => {
					calendar.hideOverlay();
					if (document.activeElement instanceof HTMLElement) {
						document.activeElement.blur();
					}
				}, 50);
			}
			this.onChangeRangeDate();
		}
	}

	private onChangeRangeDateTimeout: any;

	onChangeRangeDate() {
		if (this.onChangeRangeDateTimeout) {
			clearTimeout(this.onChangeRangeDateTimeout);
		}
		
		this.onChangeRangeDateTimeout = setTimeout(() => {
			this.dateHelperService.checkAndInitDateRangeEndDate({
				datePickerRangeDates: this.rangeDates,
			});
			let response = this.dateHelperService.seStartAndEndDates({
				datePickerRangeDates: this.rangeDates,
				startDateString: this.filters.start_date,
				endDateString: this.filters.end_date,
			});
			this.configDay.startDate = response.start_date;

			this.filters.start_date = response.start_date;
			this.filters.end_date = response.end_date;

			this.sendGetScheduledListingRequest();
		}, 100);
	}

	viewWorkOrder(wo) {
		let params = {
			filters: JSON.stringify({
				work_order_id: [
					{
						value: _.get(wo, "work_order_id"),
						operator: "and",
						matchMode: "equals",
					},
				],
			}),
		};
		let paramString = this.helperService.convertQueryParams(params, "");

		window.open(`${environment.BASE_URL}/#/work-orders/${wo.id}`, "_blank");
	}

	// Work Order
	multiEditWorkOrders(workOrders) {
		let isError = false;
		_.each(workOrders, (item) => {
			let isReschedulable = this.isReschedulable({
				statusReason: item.status_reason,
			});
			if (!isReschedulable) {
				this.helperService.errorMessage(
					`${item.work_order_id} ${this.errorReschedule}`
				);
				isError = true;
				return false;
			}
		});
		if (isError) {
			return;
		}

		this.wosListingChanged = this.unionWorkOrders(
			this.wosListingChanged,
			workOrders
		);

		this.unscheduledWosListing = _.differenceBy(
			this.unscheduledWosListing,
			workOrders,
			"id"
		);
		this.unscheduledWosSelected = _.differenceBy(
			this.unscheduledWosSelected,
			workOrders,
			"id"
		);

		this.scheduledWosListing = this.unionWorkOrders(
			this.scheduledWosListing,
			workOrders
		);

		this.editByDatesWos({ workOrders: workOrders });

		//  dataChanged: true
		this.saveChanges(true);

		this.reloadPageData();
	}

	private editByDatesWos({ workOrders = [] }) {
		if (_.isEmpty(this.selectedMonthItem)) {
			return;
		}

		this.byDatesWosListing = this.unionWorkOrders(
			this.byDatesWosListing,
			workOrders
		);
		this.byDatesWosListing = _.filter(this.byDatesWosListing, (item) => {
			return moment(item.appoinment_start).isSame(
				this.selectedMonthItem.date,
				"day"
			);
		});

		this.byDatesWosSelected = this.unionWorkOrders(
			this.byDatesWosSelected,
			workOrders
		);
		this.byDatesWosSelected = _.intersectionBy(
			this.byDatesWosSelected,
			this.byDatesWosListing,
			"id"
		);
	}

	private getWOAppointmentStartDateReset(workOrder) {
		return moment(_.get(workOrder, "appoinment_start"))
			.set({ hour: 0, minute: 0, second: 0 })
			.format(DATE_TIME_FORMAT);
	}

	private getWOAppointmentEndDateReset(workOrder) {
		return moment(_.get(workOrder, "appoinment_end"))
			.set({ hour: 1, minute: 0, second: 0 })
			.format(DATE_TIME_FORMAT);
	}

	unscheduleWorkOrders(workOrders) {
		let isError = false;
		_.each(workOrders, (item) => {
			let isReschedulable = this.isReschedulable({
				statusReason: item.status_reason,
			});
			if (!isReschedulable) {
				this.helperService.errorMessage(
					`${item.work_order_id} ${this.errorReschedule}`
				);
				isError = true;
				return false;
			}
		});
		if (isError) {
			return;
		}

		// console.log('unscheduleWorkOrders()');
		workOrders = _.map(workOrders, (item) => {
			return {
				...item,
				dataChanged: true,
				appoinment_start: this.getWOAppointmentStartDateReset(item),
				appoinment_end: this.getWOAppointmentEndDateReset(item),
			};
		});
		this.wosListingChanged = this.unionWorkOrders(
			this.wosListingChanged,
			workOrders
		);

		this.unscheduledWosListing = this.unionWorkOrders(
			this.unscheduledWosListing,
			workOrders
		);

		this.scheduledWosListing = _.differenceBy(
			this.scheduledWosListing,
			workOrders,
			"id"
		);
		this.scheduledWosSelected = _.differenceBy(
			this.scheduledWosSelected,
			workOrders,
			"id"
		);

		this.byDatesWosListing = _.differenceBy(
			this.byDatesWosListing,
			workOrders,
			"id"
		);
		this.byDatesWosSelected = _.differenceBy(
			this.byDatesWosSelected,
			workOrders,
			"id"
		);
		// console.log(this.unscheduledWosListing);
		// console.log(this.scheduledWosListing);
		this.reloadPageData();
		this.saveChanges();
	}

	private setDayPilotResources() {
		let groupBy = _.get(this.schedulerConfig, "group_by");
		let groups = _.get(this.schedulerConfig, `filter.${groupBy}`);
		let params = {
			group_by: _.get(this.valueMappings, `${groupBy}.key_in_engineer`),
			groups: _.isEmpty(groups)
				? _.get(this.valueMappings, `${groupBy}.options`)
				: groups,
			engineers: this.getFilteredEngineers(),
		};

		// this.dayPilotConfig.resources =
		// 	this.dataService.getDayPilotResources(params);
	}

	private setDayPilotEvents() {
		let dayPilotEvents = [];

		_.each(this.calendarEventsV2, (item) => {
			let startDate = moment(item.appoinment_start)
				.set("second", 0)
				.format(DATE_TIME_FORMAT);
			let endDate = moment(item.appoinment_end)
				.set("second", 0)
				.format(DATE_TIME_FORMAT);

			dayPilotEvents.push({
				id: this.helperService.generateRandomUuid(),
				// start: new DayPilot.Date(startDate),
				// end: new DayPilot.Date(endDate),
				// 'start': moment(item.appoinment_start).format(),
				// 'end': moment(item.appoinment_end).format(),
				resource: item.engineer_id,

				// 'start': '2022-12-01T00:00:00',
				// 'end': '2022-12-01T01:00:00',
				// 'resource': 'AM-000004',
				workOrder: item,
				cancelBubble: true,
			});
		});

		this.dayPilotEvents = dayPilotEvents;
	}

	getFilteredEngineers() {
		let specificEngineers = _.get(this.schedulerConfig, `filter.engineers`);
		let engineers = _.isEmpty(specificEngineers)
			? this.ENGINEER_OPTIONS
			: specificEngineers;
		let filters = _.get(this.schedulerConfig, `filter`, {});

		_.each(filters, (itemValue, itemKey) => {
			if (itemKey == "engineers") {
				return true; // continue
			} else if (itemKey == "team_groups") {
				if (!_.isEmpty(itemValue)) {
					engineers = _.filter(engineers, (engineer) =>
						_.chain(itemValue)
							.map("value")
							.includes(engineer.team_group)
							.value()
					);
				}
			} else if (itemKey == GROUP_VALUE.VENDOR) {
				if (!_.isEmpty(itemValue)) {
					engineers = _.filter(engineers, (engineer) =>
						_.chain(itemValue)
							.map("value")
							.includes(engineer.vendor_external_id)
							.value()
					);
				}
			} else if (itemKey == GROUP_VALUE.EMPLOYEE_TYPE) {
				if (!_.isEmpty(itemValue)) {
					engineers = _.filter(engineers, (engineer) =>
						_.chain(itemValue)
							.map("value")
							.includes(engineer.employee_type)
							.value()
					);
				}
			} else {
				let fieldKeyInEngineer = itemKey;
				switch (itemKey) {
					case "b_care_araes":
						fieldKeyInEngineer = "care_areas";
						break;
					default:
						break;
				}

				if (!_.isEmpty(itemValue)) {
					let filteredEngineers2 = _.filter(engineers, (engineer) => {
						const hasMatchingOpc = _.some(
							engineer[fieldKeyInEngineer],
							(x) => {
								const isMatch = itemValue.includes(x.id);
								return isMatch;
							}
						);
						return hasMatchingOpc;
					});
					engineers = filteredEngineers2;
				}
			}
		});
		this.filteredEngineers = engineers;

		return engineers;
	}

	private getMonthViewFilteredEngineers() {
		let filteredEngineers = this.getFilteredEngineers();

		return filteredEngineers.length == this.ENGINEER_OPTIONS.length
			? []
			: filteredEngineers;
	}

	private onDayPilotEventChange({ dayPilotCallBackResponse, action = null }) {
		let newAppointmentStartDate = moment(
			dayPilotCallBackResponse.newStart.toDate()
		)
			.utc()
			.format(DATE_TIME_FORMAT);
		let newAppointmentEndDate = moment(
			dayPilotCallBackResponse.newEnd.toDate()
		)
			.utc()
			.format(DATE_TIME_FORMAT);

		_.set(dayPilotCallBackResponse, "e.data.workOrder.dataChanged", true);
		_.set(
			dayPilotCallBackResponse,
			"e.data.workOrder.appoinment_start",
			newAppointmentStartDate
		);
		_.set(
			dayPilotCallBackResponse,
			"e.data.workOrder.appoinment_end",
			newAppointmentEndDate
		);

		if (action == EVENT_ACTION.MOVED) {
			let newEngineer = _.find(this.ENGINEER_OPTIONS, {
				external_id: dayPilotCallBackResponse.newResource,
			});
			_.set(
				dayPilotCallBackResponse,
				"e.data.workOrder.engineer_id",
				newEngineer.external_id
			);
			_.set(
				dayPilotCallBackResponse,
				"e.data.workOrder.engineer_full_name",
				newEngineer.full_name
			);
		}
		let workOrder = _.get(dayPilotCallBackResponse, "e.data.workOrder");

		this.unscheduledWosListing = _.differenceBy(
			this.unscheduledWosListing,
			[workOrder],
			"id"
		);
		this.scheduledWosListing = this.unionWorkOrders(
			this.scheduledWosListing,
			[workOrder]
		);
		this.wosListingChanged = this.unionWorkOrders(this.wosListingChanged, [
			workOrder,
		]);
		this.saveChanges();
	}

	private onDayPilotEventUnschedule(dayPilotCallBackResponse): void {
		// let dp = this.DayScheduler.control;
		// dp.events.remove(dayPilotCallBackResponse);

		let workOrder = _.get(dayPilotCallBackResponse, "data.workOrder");
		_.set(dayPilotCallBackResponse, "e.data.workOrder.dataChanged", true);
		_.set(
			dayPilotCallBackResponse,
			"data.workOrder.appoinment_start",
			this.getWOAppointmentStartDateReset(workOrder)
		);
		_.set(
			dayPilotCallBackResponse,
			"data.workOrder.appoinment_end",
			this.getWOAppointmentEndDateReset(workOrder)
		);
		// _.set(dayPilotCallBackResponse, 'data.workOrder.engineer_id', null);
		// _.set(dayPilotCallBackResponse, 'data.workOrder.engineer_full_name', null);

		workOrder = _.get(dayPilotCallBackResponse, "data.workOrder");
		this.unscheduledWosListing = this.unionWorkOrders(
			this.unscheduledWosListing,
			[workOrder]
		);
		this.scheduledWosListing = _.differenceBy(
			this.scheduledWosListing,
			[workOrder],
			"id"
		);
		this.byDatesWosListing = _.differenceBy(
			this.byDatesWosListing,
			[workOrder],
			"id"
		);
		this.wosListingChanged = this.unionWorkOrders(this.wosListingChanged, [
			workOrder,
		]);
		this.saveChanges();
	}

	private unionWorkOrders(oldListing, newListing) {
		return _.chain(oldListing)
			.differenceBy(newListing, "id")
			.unionBy(newListing, "id")
			.value();
	}

	private isHoliday({
		dayIndex = null,
		date = null,
		calendarView = this.VIEW_DAY,
	}) {
		let tempDate = null;

		if (calendarView == this.VIEW_MONTH) {
			tempDate = this.getDateOfMonth(dayIndex);
		} else {
			tempDate = date;
		}

		let isHoliday = false;
		_.each(this.HOLIDAYS, (item) => {
			let compareParams = {
				compareDate: tempDate,
				startDate: item["holiday_start_date"],
				endDate: item["holiday_end_date"],
			};

			if (this.dateHelperService.isDateBetween(compareParams)) {
				isHoliday = item.display_in_calendar;
				return false;
			}
		});

		return isHoliday;
	}

	private isWeekend({
		dayIndex = null,
		date = null,
		calendarView = this.VIEW_DAY,
	}) {
		let weekOfDay = null;

		if (calendarView == this.VIEW_MONTH) {
			weekOfDay = this.getWeekOfDay(dayIndex);
		} else {
			weekOfDay = this.getWeekOfDay(moment(date).day());
		}

		return weekOfDay == "SUN" || weekOfDay == "SAT";
	}

	private getWeekOfDay(index) {
		let week = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
		return week[index % 7];
	}

	private momentSelectedMonth() {
		return moment(this.schedulerConfig.selected_month);
	}
	private firstDayOfMonth() {
		let dayByMonth = this.momentSelectedMonth().startOf("month").day();

		return dayByMonth == 7 ? 0 : dayByMonth;
	}
	private endDayOfMonth() {
		return (
			this.firstDayOfMonth() +
			this.momentSelectedMonth().daysInMonth() -
			1
		);
	}
	private getDayOfMonthNumber(index) {
		return index >= this.firstDayOfMonth() && index <= this.endDayOfMonth()
			? index - this.firstDayOfMonth()
			: null;
	}
	private getDateOfMonth(itemIndex) {
		let day = this.getDayOfMonthNumber(itemIndex);

		return day !== null
			? this.momentSelectedMonth()
					.set("date", this.getDayOfMonthNumber(itemIndex) + 1)
					.format("YYYY-MM-DD")
			: null;
	}

	private getMonthCalendarListing({ type = null, date }) {
		let wosOnDate = _.filter(this.calendarEventsV2, (item) => {
			return moment(item.appoinment_start).isSame(date, "day");
		});
		let engineerIds = _.map(
			this.getMonthViewFilteredEngineers(),
			"external_id"
		);
		let wosFilteredByEngineers = _.filter(wosOnDate, (item) => {
			return _.includes(engineerIds, item.engineer_id);
		});
		let wosNotInFilteredByEngineers = _.differenceBy(
			wosOnDate,
			wosFilteredByEngineers,
			"id"
		);

		return type == this.MONTH_LISTING_TYPE_FILTERED
			? wosFilteredByEngineers
			: wosNotInFilteredByEngineers;
	}

	private setMonthCalendarConfig() {
		let dayElements = Array(42);

		dayElements = _.map(dayElements, (itemObj, itemIndex) => {
			return {
				week_of_day: this.getWeekOfDay(itemIndex),
				day: this.getDayOfMonthNumber(itemIndex),
				is_holiday: this.isHoliday({
					dayIndex: itemIndex,
					calendarView: this.VIEW_MONTH,
				}),
				is_weekend: this.isWeekend({
					dayIndex: itemIndex,
					calendarView: this.VIEW_MONTH,
				}),
				date: this.getDateOfMonth(itemIndex),
				work_orders_filtered: this.getMonthCalendarListing({
					type: this.MONTH_LISTING_TYPE_FILTERED,
					date: this.getDateOfMonth(itemIndex),
				}),
				work_orders_scheduled: this.getMonthCalendarListing({
					date: this.getDateOfMonth(itemIndex),
				}),
			};
		});

		this.monthCalendarConfig = {
			...this.monthCalendarConfig,
			rows: _.chunk(dayElements, 7),
		};
	}

	diveIntoDay(item) {
		// console.log("diveIntoDay()");
		// console.log(item);

		this.rangeDates[0] = moment(item.date).toDate();
		this.rangeDates[1] = moment(item.date).toDate();
		this.schedulerConfig.view = this.VIEW_DAY;

		this.onChangeRangeDate();
	}

	setByDatesWosListing(item, type) {
		this.selectedMonthItem = item;
		this.activeTab = this.TAB_SELECTED;
		this.sendGetByDatesTableListingRequest();
	}

	onClickTab(tab: string) {
		if (this.activeTab === tab) {
			return;
		}

		this.activeTab = tab;

		if (!this.loadedTabs.has(tab)) {
			if (tab === this.TAB_SCHEDULED) {
				this.sendGetScheduledTableListingRequest();
			} else if (tab === this.TAB_UNSCHEDULED) {
				this.sendGetUnscheduledListingRequest();
			} else if (tab === this.TAB_SELECTED) {
				this.sendGetByDatesTableListingRequest();
			}
		}
	}

	// table functions start
	getTablePreconfig(): any {
		return {
			table_all_columns: TABLE_COLUMNS,
			prefilters: [
				{
					key: null,
				},
			],
		};
	}

	reloadTable(
		action = "default",
		params: any = {},
		options = { tableConfigType: null }
	) {
		let { tableConfigType } = options;
		let tableConfig = null;

		switch (tableConfigType) {
			case this.TAB_UNSCHEDULED:
				tableConfig = this.unscheduledWoTableConfig;
				break;
			case this.TAB_SCHEDULED:
				tableConfig = this.scheduledWoTableConfig;
				break;
			case this.TAB_SELECTED:
				tableConfig = this.byDatesWoTableConfig;
				break;
		}

		if (this.reloadTableTimeouts[tableConfigType]) {
			clearTimeout(this.reloadTableTimeouts[tableConfigType]);
		}
		const timeout =
			action === this.tableHelperService.ACTION_SEARCH_KEY ||
			action === this.tableHelperService.ACTION_FILTER
				? DEFAULT_TIMEOUT.SEARCHING_INPUT
				: 0;
		this.reloadTableTimeouts[tableConfigType] = setTimeout(() => {
			if (tableConfigType !== this.activeTab) {
				return;
			}
			params = {
				...params,
				...this.getTablePreconfig(),
			};
			if (
				_.get(params, "checkIsTableChanged", true) &&
				!this.checkIsTableChanged(
					tableConfigType,
					tableConfig,
					action,
					params
				)
			) {
				return;
			}
			tableConfig = this.tableHelperService.setTableConfigByAction(
				tableConfig,
				action,
				params
			);

			switch (tableConfigType) {
				case this.TAB_UNSCHEDULED:
					this.unscheduledWoTableConfig = tableConfig;
					break;
				case this.TAB_SCHEDULED:
					this.scheduledWoTableConfig = tableConfig;
					break;
				case this.TAB_SELECTED:
					this.byDatesWoTableConfig = tableConfig;
					break;
			}

			// this.tableHelperService.setLocation({ url: `/${this.base_api_url}`, table_config: this.unscheduledWoTableConfig });
			if (action != this.tableHelperService.ACTION_CHANGE_COLUMN) {
				if (tableConfigType == this.TAB_UNSCHEDULED) {
					this.sendGetUnscheduledListingRequest();
				} else if (tableConfigType == this.TAB_SCHEDULED) {
					this.sendGetScheduledTableListingRequest();
				} else if (tableConfigType == this.TAB_SELECTED) {
					this.sendGetByDatesTableListingRequest();
				}
			}
		}, timeout);
	}

	checkIsTableChanged(
		tableConfigType: string,
		tableConfig: any,
		action: string,
		params: any
	): boolean {
		let tempTableConfig = this.tableHelperService.setTableConfigByAction(
			_.cloneDeep(tableConfig),
			action,
			_.cloneDeep(params)
		);
		let tempParams =
			this.tableHelperService.convertConfigToRequestParams(tempTableConfig);

		if (tableConfigType === this.TAB_SCHEDULED) {
			let startDate = null;
			let endDate = null;

			if (this.schedulerConfig.view == this.VIEW_DAY) {
				startDate = moment(this.rangeDates[0]).format(DATE_FORMAT);
				endDate = moment(this.rangeDates[1]).format(DATE_FORMAT);
			} else if (this.schedulerConfig.view == this.VIEW_MONTH) {
				startDate = moment(this.schedulerConfig.selected_month)
					.startOf("month")
					.format(DATE_FORMAT);
				endDate = moment(this.schedulerConfig.selected_month)
					.endOf("month")
					.format(DATE_FORMAT);
			}

			tempParams.start_date = startDate;
			tempParams.end_date = endDate;
			tempParams.show_closed_work_order = this.isShowClosedWorkOrder;
		} else if (tableConfigType === this.TAB_SELECTED && this.selectedMonthItem) {
			let dateStr = moment(this.selectedMonthItem.date).format(DATE_FORMAT);
			tempParams.start_date = dateStr;
			tempParams.end_date = dateStr;
			tempParams.show_closed_work_order = this.isShowClosedWorkOrder;
		}

		let tableParams = _.cloneDeep(
			this.helperService.convertToTableListingParams(tempParams)
		);
		let requestParamsString = this.helperService.convertQueryParams(
			tableParams,
			""
		);
		let isNotSameParams = !_.isEqual(
			this.previousTableParams[tableConfigType],
			requestParamsString
		);

		this.previousTableParams[tableConfigType] = requestParamsString;
		return (
			(isNotSameParams ||
				action == this.tableHelperService.ACTION_CHANGE_COLUMN) &&
			this.checkIsNotEditingFilterParams(tableParams)
		);
	}

	private checkIsNotEditingFilterParams(tableParams) {
		let result = _.chain(tableParams)
			.get("filter")
			.map((value, key) => value.criterias)
			.flatten()
			.filter((x) => x.matchMode != "isEmpty" && x.matchMode != "isNotEmpty")
			.some({ value: null })
			.value();

		return !result;
	}

	exportTableListing({ apiUrl, fileName, tableConfig }) {
		// console.log("exportTableListing()");
		// console.log(this.filters);
		// console.log(this.schedulerConfig);
		// console.log(this.rangeDates);
		// console.log(this.selectedMonthItem);

		let queryParams = null;
		if (fileName == "scheduled-work-orders") {
			let startDate = null;
			let endDate = null;
			if (this.schedulerConfig.view == this.VIEW_DAY) {
				startDate = moment(this.rangeDates[0]).format("YYYY-MM-DD");
				endDate = moment(this.rangeDates[1]).format("YYYY-MM-DD");
			}
			if (this.schedulerConfig.view == this.VIEW_MONTH) {
				startDate = moment(this.schedulerConfig.selected_month)
					.startOf("month")
					.format("YYYY-MM-DD");
				endDate = moment(this.schedulerConfig.selected_month)
					.endOf("month")
					.format("YYYY-MM-DD");
			}

			queryParams = {
				start_date: startDate,
				end_date: endDate,
			};
		}
		if (fileName == "work-orders-by-dates") {
			if (!this.selectedMonthItem) {
				this.helperService.errorMessage(
					"Must select any date first before export"
				);
			}

			queryParams = {
				start_date: _.get(this.selectedMonthItem, "date"),
				end_date: _.get(this.selectedMonthItem, "date"),
			};
		}

		this.downloadService.startDownload({
			id: fileName,
			title: fileName,
			url: apiUrl + `/v2`,
			params: this.tableHelperService.convertConfigToRequestParams(
				tableConfig
			),
			query_params: {
				...queryParams,
				show_closed_work_order: this.isShowClosedWorkOrder,
			},
		});
	}
	// table functions end

	private isReschedulable({ statusReason }): Boolean {
		return (
			statusReason == "pending-booking-acceptance" ||
			statusReason == "booking-accepted" ||
			statusReason == "booking-rejected" ||
			statusReason == "scheduled"
		);
	}

	async onChangeUsShowClosedWorkOrder() {
		await this.sendGetScheduledListingRequest();
		this.reloadPageData();
	}

	getEncryptedWoId(woId: string): string {
		return this.encryptionService.encrypt(woId);
	}

	getFilteredEngineersBySchedulerConfig(): any[] {
		let groupBy = this.schedulerConfig.group_by;

		let selectedFilter = this.schedulerConfig.filter[groupBy];

		if (selectedFilter && selectedFilter.length > 0) {
			return this.getFilteredEngineers().filter(
				(engineer) => selectedFilter.includes(engineer[groupBy]) // Cocokkan dengan properti engineer
			);
		}
		return [];
	}

	getGroupName(engineer: any, filterKey: string): string | null {
		const propertyMapping: { [key: string]: string } = {
			branches: "branch_name",
			agencies: "agency",
			care_areas: "care_area",
			opcs: "opc",
			regions: "region",
			functional_opc: "functional_opc_code",
			sub_bme_teams: "team_name",
			team_group: "team_group",
		};

		if (!propertyMapping[filterKey]) {
			return null;
		}

		if (filterKey === "team_group") {
			console.log("check team group: " + JSON.stringify(engineer));
			return engineer.team_group || null;
		}

		let targetProperty = propertyMapping[filterKey];

		if (
			engineer[filterKey] &&
			Array.isArray(engineer[filterKey]) &&
			engineer[filterKey].length > 0
		) {
			return engineer[filterKey][0][targetProperty] || null;
		}

		return null;
	}

	updateAppointmentTime(schedule: any): any {
		const forceSetHour = (dateString: string, hour: number): string => {
			return dateString.replace(
				/\d{2}:\d{2}:\d{2}$/,
				`${hour.toString().padStart(2, "0")}:00:00`
			);
		};

		return {
			...schedule,
			appoinment_start: forceSetHour(schedule.startTime, 0), // 00:00:00
			appoinment_end: forceSetHour(schedule.endTime, 1), // 01:00:00
		};
	}
}
